import script from "./EditServiceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditServiceModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditServiceModal.vue?vue&type=style&index=0&id=e5305846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5305846"]])

export default __exports__